import linkifyHtml from 'linkify-html';

/**
 * @param {self} this
 * @returns {string}
 * Replace numbers starts with 0 or +, longer than 7 characters with clickable tel link
 */
export const replacePhone = (content: string, className = 'underline' as string): string =>
    content.replace(
        /(0|\+)(\d\s*){7,}\d/g,
        (string) => `<a class="${className}" href="tel:${string.replace(/\s/g, '')}">${string.trim()}</a>`,
    );

/**
 * @param {string} content
 * @param {object} options
 * @returns {string}
 * Replace urls and emails with clickable HTML href link in given content
 */
export const linkify = (content: string, options: object, shouldReplacePhones = true as boolean): string => {
    const linkOptions = {
        defaultProtocol: 'https',
        target: '_blank',
        className: () => 'underline',
        format: (value: string, type: string) =>
            type === 'url' && value.length > 50 ? `${value.slice(0, 50)}…` : value,
        ...options,
    };
    let result = linkifyHtml(content, linkOptions);
    if (shouldReplacePhones) {
        result = replacePhone(result, linkOptions.className());
    }
    return result;
};

export const unlinkify = (content: string): string => content.replace(/<a[^>]*>(.*?)<\/a>/gi, '$1 ');
